import React, { useEffect } from "react";

export const apkUrl = process.env.REACT_APP_URL_APP;
export const instagram = process.env.REACT_APP_URL_INSTAGRAM;
export const contactMail = process.env.REACT_APP_CONTACT_MAIL;
export const whatsApp = process.env.REACT_APP_WHATSAPP_NUMBER;
export const contactPhone = process.env.REACT_APP_CONTACT_PHONE;
export const playUrl = process.env.REACT_APP_URL_PLAY_STORE;


const AppLink = () => {
  useEffect(() => {
    window.location.href = apkUrl;
  }, []);

  return null;
};

export default AppLink;
